import "./Footer.scss";
import { FaLocationArrow, FaMobileAlt, FaEnvelope } from "react-icons/fa";
import Payment from "../../assets/payments.png";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="footer">

            <div className="footer-content">
                <div className="col">
                    <div className="title"> FOLLOW US </div>
                    <div className="text">
                        <div className="social-media">
                            <div className="icon">
                                <FaFacebookF size={20} />
                            </div>
                            <div className="icon v3">
                                <FaInstagram size={20} />
                            </div>
                            <div className="icon v4">
                                <FaWhatsapp size={20} />
                            </div>
                        </div>

                    </div>
                </div>

                {/* contact */}
                <div className="col">
                    <div className="title"> CONTACT US </div>

                    <div className="c-item">
                        <FaEnvelope />
                        <div className="text"> info@thedapperdaddy.com</div>
                    </div>

                    <div className="c-item">
                        <FaLocationArrow />
                        <div className="text"> Uper Kota, Sayyedo Ki Masjid Ke Saamne, Jalore, Rajasthan 343001 </div>
                    </div>

                    <div className="c-item">
                        <FaMobileAlt />
                        <div className="text"> +91- 7300202769</div>
                    </div>

                </div>

                {/* About */}
                <div className="col">
                    <div className="title">
                        T & C POLICY
                    </div>
                    <div className="text">
                        I Have Been Using Dapper Daddy's Products
                        For a Few Months, And The Results Blow Me Away.
                        My Skin Feels Healthier, More Vibrant, And
                        Incredibly Soft. Knowing That These Products Are
                        Free From Sulfates, Parab.
                    </div>
                </div>


            </div>

            <div className="bottom-bar">
                <div className="bottom-bar-content">
                    <div className="text">
                        © 2023 AJ Solution. All rights reserved.
                    </div>
                    <img src={Payment} alt="" />
                </div>
            </div>

        </footer>
    )
};

export default Footer;
